import { PluginKey } from "prosemirror-state";

export const key = new PluginKey<number | null>("cellSelection");
